import React from 'react';
import imgmake1 from "./images/ritual-make1.png";
import imgmake2 from "./images/ritual-make2.png";
import imgmake3 from "./images/ritual-make3.png";
import imgmake4 from "./images/ritual-make4.png";

class Section4 extends React.Component {
    render() { 
        return <React.Fragment><div className="unipadding maker">
        <h2>Make Your Self</h2>
        <p>
          Commit to yourself every single day with <a href="#">@Ritual</a>
        </p>
      </div>
      <div className="unipadding gallery-container">
        <div className="gallery">
          <img src={imgmake1} alt="" srcset="" />
        </div>
        <div className="gallery">
          <img src={imgmake2} alt="" srcset="" />
        </div>
        <div className="gallery">
          <img src={imgmake3} alt="" srcset="" />
        </div>
        <div className="gallery">
          <img src={imgmake4} alt="" srcset="" />
        </div>
      </div>
      <hr />
      
      <div className="unipadding">
        <div className="div50">
          <h3>Subscribe for updates, exclusive promotions, and more.</h3>
        </div>
        <div className="div50">
          <form>
            <input type="text" placeholder="Enter your email" />
            <input type="submit" value="Subscribe" />
          </form>
          <div className="icons">
            <ul
              id="footer_container_row-0_column-0_social-list"
              className="SocialList-sc-1a8rrp5-0 bJUWGQ"
            >
              <li>
                <a
                  href="https://www.facebook.com/ritual"
                  hreflang="x-default"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Ritual on Facebook"
                  ><svg
                    width="24"
                    height="24"
                    version="1.1"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      fill-rule="evenodd"
                      stroke="none"
                      stroke-width="1"
                    >
                      <g transform="translate(-698.000000, -1395.000000)">
                        <rect
                          width="1366"
                          height="1997"
                          x="0"
                          y="0"
                          fill="#FFF"
                        ></rect>
                        <g fill="#142B6F">
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M13.2625568,22.8 L13.2625568,12.9472831 L16.5614974,12.9472831 L17.0553923,9.10743565 L13.2625568,9.10743565 L13.2625568,6.65586273 C13.2625568,5.54413727 13.5704567,4.7864633 15.1607337,4.7864633 L17.1889931,4.78560534 L17.1889931,1.35128694 C16.8381128,1.30457579 15.6341844,1.2 14.2335159,1.2 C11.3093231,1.2 9.30730843,2.98941849 9.30730843,6.27569113 L9.30730843,9.10743565 L6,9.10743565 L6,12.9472831 L9.30730843,12.9472831 L9.30730843,22.8 L13.2625568,22.8 Z"
                                  transform="translate(0.000000, 1215.000000) translate(98.000000, 80.000000) translate(600.000000, 100.000000)"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/ritual"
                  hreflang="x-default"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Ritual on Instagram"
                  ><svg
                    width="24"
                    height="24"
                    version="1.1"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      fill-rule="evenodd"
                      stroke="none"
                      stroke-width="1"
                    >
                      <g transform="translate(-754.000000, -1395.000000)">
                        <rect
                          width="1366"
                          height="1997"
                          x="0"
                          y="0"
                          fill="#FFF"
                        ></rect>
                        <g fill="#142B6F" fill-rule="nonzero">
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M12,3.1467 C14.8836,3.1467 15.2256,3.1575 16.365,3.2097 C19.2918,3.3429 20.6589,4.7316 20.7921,7.6368 C20.8443,8.7753 20.8542,9.1173 20.8542,12.0009 C20.8542,14.8854 20.8434,15.2265 20.7921,16.365 C20.658,19.2675 19.2945,20.6589 16.365,20.7921 C15.2256,20.8443 14.8854,20.8551 12,20.8551 C9.1164,20.8551 8.7744,20.8443 7.6359,20.7921 C4.7019,20.658 3.342,19.263 3.2088,16.3641 C3.1566,15.2256 3.1458,14.8845 3.1458,12 C3.1458,9.1164 3.1575,8.7753 3.2088,7.6359 C3.3429,4.7316 4.7064,3.342 7.6359,3.2088 C8.7753,3.1575 9.1164,3.1467 12,3.1467 Z M12,1.2 C9.0669,1.2 8.6997,1.2126 7.5477,1.2648 C3.6255,1.4448 1.4457,3.621 1.2657,7.5468 C1.2126,8.6997 1.2,9.0669 1.2,12 C1.2,14.9331 1.2126,15.3012 1.2648,16.4532 C1.4448,20.3754 3.621,22.5552 7.5468,22.7352 C8.6997,22.7874 9.0669,22.8 12,22.8 C14.9331,22.8 15.3012,22.7874 16.4532,22.7352 C20.3718,22.5552 22.557,20.379 22.7343,16.4532 C22.7874,15.3012 22.8,14.9331 22.8,12 C22.8,9.0669 22.7874,8.6997 22.7352,7.5477 C22.5588,3.6291 20.3799,1.4457 16.4541,1.2657 C15.3012,1.2126 14.9331,1.2 12,1.2 Z M12,6.4542 C8.9373,6.4542 6.4542,8.9373 6.4542,12 C6.4542,15.0627 8.9373,17.5467 12,17.5467 C15.0627,17.5467 17.5458,15.0636 17.5458,12 C17.5458,8.9373 15.0627,6.4542 12,6.4542 Z M12,15.6 C10.0119,15.6 8.4,13.989 8.4,12 C8.4,10.0119 10.0119,8.4 12,8.4 C13.9881,8.4 15.6,10.0119 15.6,12 C15.6,13.989 13.9881,15.6 12,15.6 Z M17.7654,4.9395 C17.049,4.9395 16.4685,5.52 16.4685,6.2355 C16.4685,6.951 17.049,7.5315 17.7654,7.5315 C18.4809,7.5315 19.0605,6.951 19.0605,6.2355 C19.0605,5.52 18.4809,4.9395 17.7654,4.9395 Z"
                                  transform="translate(0.000000, 1215.000000) translate(98.000000, 80.000000) translate(600.000000, 100.000000) translate(56.000000, 0.000000)"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.pinterest.com/MyRitual"
                  hreflang="x-default"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Ritual on Pinterest"
                  ><svg
                    width="24"
                    height="24"
                    version="1.1"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      fill-rule="evenodd"
                      stroke="none"
                      stroke-width="1"
                    >
                      <g transform="translate(-810.000000, -1395.000000)">
                        <rect
                          width="1366"
                          height="1997"
                          x="0"
                          y="0"
                          fill="#FFF"
                        ></rect>
                        <g fill="#142B6F" fill-rule="nonzero">
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M12,1.2 C6.0357,1.2 1.2,6.0348 1.2,12 C1.2,16.5756 4.0467,20.4834 8.0643,22.0566 C7.9698,21.2025 7.8843,19.8921 8.1021,18.9597 C8.2983,18.1164 9.3684,13.5912 9.3684,13.5912 C9.3684,13.5912 9.0453,12.9441 9.0453,11.9874 C9.0453,10.4862 9.9156,9.3648 10.9992,9.3648 C11.9199,9.3648 12.3654,10.0569 12.3654,10.8858 C12.3654,11.8119 11.7759,13.197 11.4708,14.4813 C11.2161,15.5559 12.0099,16.4334 13.0701,16.4334 C14.9898,16.4334 16.4649,14.4093 16.4649,11.4879 C16.4649,8.9022 14.6073,7.0941 11.9541,7.0941 C8.8815,7.0941 7.0779,9.399 7.0779,11.7804 C7.0779,12.7083 7.4352,13.7046 7.8816,14.2446 C7.9698,14.3517 7.9824,14.4462 7.9563,14.5551 L7.6566,15.7791 C7.6089,15.9771 7.5,16.0194 7.2948,15.924 C5.9457,15.2958 5.1024,13.3239 5.1024,11.7399 C5.1024,8.3334 7.5774,5.2041 12.2385,5.2041 C15.9852,5.2041 18.8967,7.8744 18.8967,11.442 C18.8967,15.1644 16.5504,18.1596 13.2924,18.1596 C12.198,18.1596 11.1693,17.5917 10.8174,16.9194 L10.1442,19.4871 C9.9003,20.4258 9.2424,21.6021 8.8014,22.3185 C9.813,22.6308 10.8867,22.8 12,22.8 C17.9643,22.8 22.8,17.9643 22.8,12 C22.8,6.0348 17.9643,1.2 12,1.2 Z"
                                  transform="translate(0.000000, 1215.000000) translate(98.000000, 80.000000) translate(600.000000, 100.000000) translate(112.000000, 0.000000)"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/ritual"
                  hreflang="x-default"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Ritual on Twitter"
                  ><svg
                    width="24"
                    height="24"
                    version="1.1"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      fill-rule="evenodd"
                      stroke="none"
                      stroke-width="1"
                    >
                      <g transform="translate(-864.000000, -1395.000000)">
                        <rect
                          width="1366"
                          height="1997"
                          x="0"
                          y="0"
                          fill="#FFF"
                        ></rect>
                        <g fill="#142B6F">
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M7.547808,21.3473684 C16.604736,21.3473684 21.557664,14.0584628 21.557664,7.73810385 C21.557664,7.53098445 21.553344,7.32489085 21.543552,7.11972981 C22.504896,6.44465672 23.340672,5.60228413 24,4.64315625 C23.117664,5.02391649 22.168224,5.28046105 21.172224,5.39619053 C22.188768,4.80411441 22.969344,3.86708797 23.337408,2.75026585 C22.385856,3.2981391 21.332448,3.69671105 20.21088,3.91129085 C19.31232,2.9815383 18.032736,2.4 16.61664,2.4 C13.897248,2.4 11.691936,4.54225432 11.691936,7.18286346 C11.691936,7.55830817 11.735232,7.92321506 11.819712,8.27348091 C7.72752,8.07363541 4.098624,6.1702072 1.6704,3.27603766 C1.247136,3.9827242 1.003488,4.80411441 1.003488,5.68015207 C1.003488,7.33962515 1.872864,8.80456825 3.194688,9.66158188 C2.38704,9.63742883 1.62816,9.42182323 0.964512,9.06325768 C0.963456,9.08321425 0.963456,9.10317083 0.963456,9.12415321 C0.963456,11.4409809 2.661024,13.3749035 4.913856,13.8134819 C4.500288,13.9227768 4.06512,13.9817139 3.61584,13.9817139 C3.298656,13.9817139 2.990112,13.9512195 2.690208,13.895453 C3.316992,15.7958038 5.134752,17.1786825 7.290144,17.2176631 C5.604576,18.5005724 3.481632,19.2651703 1.17456,19.2651703 C0.777312,19.2651703 0.385344,19.2430689 0,19.198866 C2.1792,20.55554 4.766592,21.3473684 7.547808,21.3473684"
                                  transform="translate(0.000000, 1215.000000) translate(98.000000, 80.000000) translate(600.000000, 100.000000) translate(166.000000, 0.000000)"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCDwWe38QlX_tFczjUC9gl6A"
                  hreflang="x-default"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Ritual on YouTube"
                  ><svg
                    width="26"
                    height="24"
                    version="1.1"
                    viewBox="0 0 26 24"
                  >
                    <g
                      fill="none"
                      fill-rule="evenodd"
                      stroke="none"
                      stroke-width="1"
                    >
                      <g fill="#142B6F" fill-rule="nonzero">
                        <g>
                          <g>
                            <g>
                              <path
                                d="M25.342154,5.80188679 C25.875,7.81839623 25.875,12 25.875,12 C25.875,12 25.875,16.1816038 25.342154,18.1981132 C25.0437603,19.3018868 24.1698929,20.1721698 23.0615733,20.4693396 C21.0367586,21 12.9375,21 12.9375,21 C12.9375,21 4.83824135,21 2.81342669,20.4693396 C1.70510708,20.1721698 0.831239703,19.3018868 0.532845964,18.1981132 C0,16.2028302 0,12 0,12 C0,12 0,7.81839623 0.532845964,5.80188679 C0.831239703,4.69811321 1.70510708,3.82783019 2.81342669,3.53066038 C4.83824135,3 12.9375,3 12.9375,3 C12.9375,3 21.0367586,3 23.0615733,3.53066038 C24.1698929,3.82783019 25.0437603,4.69811321 25.342154,5.80188679 Z M10.3372117,15.884434 L17.0723847,12.0212264 L10.3372117,8.13679245 L10.3372117,15.884434 Z"
                                transform="translate(-451.000000, -953.000000) translate(135.000000, 836.000000) translate(0.000000, 117.000000) translate(316.000000, 0.000000)"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div></React.Fragment>;
    }
}
 
export default Section4;